import { useSelector } from 'react-redux';
import { selectAvailableCategoryWithTimePeriod } from '../../selectors/menu';
import { ParsedCategory } from '../../utils/menu';

/**
 * Emoji-prefixed, alphabetically-sorted time-period category banners.
 * Shared by Banner and any embedded usage (e.g. the Current Step card) so the
 * banner list is computed the same way everywhere.
 */
const useBanners = (): ParsedCategory[] => {
  const availableCategoryWithTimePeriod = useSelector(
    selectAvailableCategoryWithTimePeriod
  );

  return [
    ...availableCategoryWithTimePeriod.filter((category) =>
      /^\p{Emoji}/u.test(category.name)
    ),
  ].sort((a, b) => a.name.localeCompare(b.name));
};

export default useBanners;
